import { Component } from '@angular/core';

@Component({
  selector: 'app-school-program-rules',
  templateUrl: './school-program-rules.component.html',
  styleUrl: './school-program-rules.component.scss'
})
export class SchoolProgramRulesComponent {

}
